import React from 'react';

const SearchIcon = () => (
    <svg className="icon-search" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5552 17.8021C6.74389 17.8021 3.65417 14.7124 3.65417 10.9011C3.65417 7.08971 6.74389 4 10.5552 4C14.3666 4 17.4563 7.08971 17.4563 10.9011C17.4563 12.4958 16.9154 13.9643 16.0069 15.1329L20.6541 19.7801L19.4342 21L14.787 16.3528C13.6184 17.2612 12.15 17.8021 10.5552 17.8021ZM15.7311 10.9011C15.7311 13.7596 13.4138 16.0769 10.5553 16.0769C7.69677 16.0769 5.37949 13.7596 5.37949 10.9011C5.37949 8.04255 7.69677 5.72527 10.5553 5.72527C13.4138 5.72527 15.7311 8.04255 15.7311 10.9011Z"
        />
    </svg>
);

export default React.memo(SearchIcon);
